import axios from "axios";

export const API_BASE_URL = (process.env.REACT_APP_API_URL || "http://localhost:8000")
  .trim()
  .replace(/\/+$/, "");
const baseUrl = axios.create({ baseURL: API_BASE_URL });

export default baseUrl;
